export default __webpack_public_path__ + "static/media/node.aca5f5f1.png";